module.exports = __webpack_public_path__ + "img/archivos.036599e7.svg";